import { Injectable } from '@angular/core';

@Injectable()
export class CollectionsService {
  groupBy<T>(array: T[], getKey: (item: T) => string | number): Map<string, T[]> {
    const groups = new Map<string, T[]>();

    for (const item of array) {
      const key = getKey(item);
      const stringKey = typeof key === 'number' ? String(key) : key;

      if (!groups.has(stringKey)) {
        groups.set(stringKey, []);
      }
      groups.get(stringKey)!.push(item);
    }

    return groups;
  }

  partition<T>(array: T[], condition: (element: T) => boolean): [T[], T[]] {
    const conditionMet: T[] = [];
    const conditionNotMet: T[] = [];

    for (const element of array) {
      if (condition(element)) {
        conditionMet.push(element);
      } else {
        conditionNotMet.push(element);
      }
    }

    return [conditionMet, conditionNotMet];
  }
}
